import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { Root } from '@/app/root'
import '@/styles/globals.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
  <StrictMode>
    <Root />
  </StrictMode>,
)
